import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import config from './config'

Vue.use(Vueaxios, axios)
export default {
  saveSettingRice (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/settingrice/save', body, header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  selectSettingRice (header, success, error) {
    Vue.axios.get(config.baseURLV2 + '/api/settingrice', header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  selectRiceSummeryByDate (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/ricesummery/bydate', body , header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  selectRiceSummeryByDateAllBranch (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/ricesummery/bydateandallbranch' , body , header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  selectRemainStock (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/remainstock/bydate' , body , header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  updateRemainStock (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/remainstock/update' , body , header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  saveRemainStock (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/remainstock/save' , body , header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  deleteRemainStock (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/remainstock/delete' , body , header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  changeRemainStock (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/remainstock/change' , body , header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  deleteStockandRemain (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/ricesummery/deletestockandremain' , body , header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  selectTransferStock (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/selecttranfer' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  approveTransferStock (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/approvetransfer' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  cancelTransferStock (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/canceltransfer' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  getHaveStock (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/getbranchhavestock' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  branchSetting (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/branchsetting' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  shortStock (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/shortstock' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  changeActivity (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/changeactivity' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  confirmActivity (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/confirmActivity' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  updateShortStock (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/updateshortstock' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  reportInvoice (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/reportInvoice' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  reportInvoiceSelect (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/reportInvoiceSelect' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  getStocks (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/stock/getstocks' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  resetStock (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/stock/resetstock' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  deleteProduct (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/product/deleteproduct' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  resetStockEgg (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/stock/mis/resetstockegg' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  getStockEgg (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/stock/mis/getstockegg' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  createInvoice (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/invoice/createinvoice' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  getInvoice (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/invoice/getinvoice' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  cancelInvoice (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/invoice/cancelinvoice' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  cancelTransferStockWhenApprove (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/cancelTransferStockWhenApprove' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  updateSale (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/sales/updateSale' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  getProductAll (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/product/getproductall' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  insertWaitingTransferStock (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/inserttransfer' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  selectTransferBranch (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/selectTransferBranch' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  approveOutTransfer (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/approveOutTransfer' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  approveInTransfer (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/mis/approveInTransfer' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  reportsYearlyCost (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/reports/yearlycost' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  reportsSaleSummery (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/reports/reportSaleSummery' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  reportsCalculateRice (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/reports/reportCalculateRice' , body, header ).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
}



// WEBPACK FOOTER //
// ./src/services/service_undefined_v2.js